import { createBrowserRouter, Navigate } from "react-router-dom";

import { ApprovalsPage } from "./routes/mgmt/ApprovalsPage";
import { HomePage } from "./routes/HomePage";
import { MgmtLayout } from "./routes/mgmt/MgmtLayout";
import { MyPayrollPage } from "./routes/MyPayrollPage";
import { NotFoundPage } from "./routes/NotFoundPage";
import { PayrollWindowPage } from "./routes/mgmt/PayrollWindowPage";
import { RequireAuth } from "./routes/RequireAuth";
import { RequireMgmt } from "./routes/RequireMgmt";
import { RootLayout } from "./routes/RootLayout";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          { index: true, element: <HomePage /> },
          { path: "my-payroll", element: <MyPayrollPage /> },
          {
            path: "mgmt",
            element: <RequireMgmt />,
            children: [
              {
                element: <MgmtLayout />,
                children: [
                  { index: true, element: <Navigate to="window" replace /> },
                  { path: "window", element: <PayrollWindowPage /> },
                  { path: "approvals", element: <ApprovalsPage /> },
                ],
              },
            ],
          },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
